import { CollateralDialogContentContainer } from './CollateralDialogContentContainer'
import { DialogConfig, DialogProps } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

interface CollateralDialogProps extends DialogProps {
  useAsCollateral: boolean
  chainId: number
}

function CollateralDialog({ token, useAsCollateral, chainId, open, setOpen }: CollateralDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <CollateralDialogContentContainer
          useAsCollateral={useAsCollateral}
          token={token}
          chainId={chainId}
          closeDialog={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}

export const collateralDialogConfig: DialogConfig<CollateralDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: CollateralDialog,
  name: 'CollateralDialog',
}
